import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import AboutAuthor from "@/components/landing/AboutAuthor";
import LinkHub from "@/components/landing/LinkHub";
import BookFeature from "@/components/landing/BookFeature";
import Newsletter from "@/components/landing/Newsletter";
import Socials from "@/components/landing/Socials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import ScrollProgress from "@/components/landing/ScrollProgress";
import useScrollReveal from "@/hooks/useScrollReveal";
import useScrollParallax from "@/hooks/useScrollParallax";

export default function App() {
  useScrollReveal();
  useScrollParallax();
  return (
    <div className="App grain min-h-screen bg-[#0a1118] text-[#f2e8d5]" data-testid="app-root">
      <ScrollProgress />
      <a
        href="#home"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[#c9a25a] focus:text-[#0a1118] focus:px-3 focus:py-2 focus:rounded"
      >
        Skip to content
      </a>
      <Navigation />
      <main id="main-content">
        <Hero />
        <LinkHub />
        <BookFeature />
        <AboutAuthor />
        <Newsletter />
        <Socials />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a1118",
            color: "#f2e8d5",
            border: "1px solid rgba(201,162,90,0.4)",
            fontFamily: "Lora, Georgia, serif",
          },
        }}
      />
    </div>
  );
}
